import React from 'react';

import { Box, Heading, Text } from '@betterment/samba-react';

export const NoResults: React.FC<{ title: string; description: string }> = ({ title, description }) => {
  return (
    <Box
      css={{
        height: '500px',
        width: '50%',
        mx: 'auto',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        justifyContent: 'center',
      }}
    >
      <Heading variant="title200"> {title} </Heading>
      <Text color="text.weak" variant="text100">
        {description}
      </Text>
    </Box>
  );
};
